var $ = require('jquery');
var _ = require('underscore');
var Entities = require('Entities');
var Marionette = require('marionette');
var Labels = EY.Consultation.Labels;
var Resources = EY.Consultation.Resources;
var User = EY.Consultation.CurrentUser;
var FilterType = EY.Consultation.Lookups.FilterType;
var FilterControlType = EY.Consultation.Lookups.FilterControlType;
var Roles = new Entities.Roles(_.sortBy(Resources.Roles, 'order'));
var SubcountriesByParent = _.chain(Resources.Geography).filter({ type: 'SubCountry' }).groupBy('parentId').value();

var fetchRolesText = function() {
    var adminGeography = new RegExp(User.adminGeography);
    var adminGeographyTypePath = new RegExp(User.adminGeographyTypePath);
    var roles = new Entities.Roles(Roles.filter(function (role) {
        var geoTypePath = _.some(_.keys(SubcountriesByParent), function (key) { return adminGeography.test(key); }) ? role.get('geographyTypePath') : _.first(role.get('geographyTypePath').split('|'));
        var roleGeography = new RegExp(role.get('geography'));

        return adminGeographyTypePath.test(geoTypePath) && roleGeography.test(User.adminGeography);
    }));
    
    return _.chain(roles.models).filter(function(e) {
        return !/Blank$/.test(e.id);
    }).map(function(item) {
        return { id: item.id, text: Labels['Role_' + item.id] };
    }).value();
};


var buildFilters = function() {
    var geography = _.chain(Resources.Geography).filter(function(item) {
        return User.roles && User.roles.length > 0 && new RegExp(User.geography.replace('//', '')).test(item.id);
    }).groupBy('type').value();

    return new Backbone.Collection([
        { name: 'region', template: '{"geographyId":"{{value}}"}', text: Labels.Region, type: FilterType.Simple, controlType: FilterControlType.Dropdown, choices: _.union(geography.SubCountry) },
        { name: 'role', template: '{"$regex":"{{value}}"}', text: Labels.Role, type: FilterType.Simple, controlType: FilterControlType.Dropdown, choices: fetchRolesText() },
    ], { comparator: 'text' });
};

var transform = function(options) {
    var filters = options.filters;
    var collection = new Backbone.Collection();
    var simple = filters.filter({ type: FilterType.Simple });

    collection.add(simple);
    return collection;
};

var Choice = Marionette.View.extend({
    events: {
        'click': 'select',
        'mouseenter': function() { this.$('ul').toggle(true).animate({ scrollTop: 0 }, 0); },
        'mouseleave': function() { this.$('ul').toggle(false); }
    },
    regions: {
        subfilter: { el: '#subfilter', replaceElement: true }
    },
    tagName: 'li',
    template: '#userFilterChoice',
    ui: {
        arrow: '.fa-chevron-right',
        filter: '#name',
        trash: '.fa-trash-o'
    },
    onRender: function() {
        if (this.model.has('subfilter')) {
            this.$el.addClass('sub-option dropup');
            this.ui.arrow.removeClass('hidden');
        }
    },
    select: function() {
        if (!this.model.has('subfilter')) {
            this.options.selections.add(this.model.clone().set('id', _.now() + ''));
        }
    }
});

var EmptyFilterChoice = Marionette.View.extend({
    tagName: 'li',
    template: '#emptyFilterChoice'
});

var Choices = Marionette.CollectionView.extend({
    attributes: {
        id: 'choices'
    },
    buildChildView: function(child, ChildViewClass) {
        var options = _.extend({}, this.options, { model: child });
        var view = new ChildViewClass(options);

        if (child.has('subfilter')) {
            view.on('render', function() {
                view.getRegion('subfilter').show(new Choices(_.extend(options, { collection: child.get('subfilter') })));
            });
        }
        return view;
    },
    className: 'dropdown-menu ey-primary',
    childView: function(model) {
        return model.get('type') === FilterType.Saved ? SavedFilterChoice : Choice;
    },
    emptyView: EmptyFilterChoice,
    tagName: 'ul'
});

var Selection = Marionette.View.extend({
    className: 'applied-filter',
    events: {
        'blur input': 'update',
        'keypress input[type=text]': 'updateOnEnter',
        'click @ui.remove': function() { this.model.collection.remove(this.model); }
    },
    template: '#userFilterSelection',
    ui: {
        remove: '#remove',
        value: 'input'
    },
    onRender: function() {
        this.ui.value.val(this.model.get('value'));
    },
    update: function(e) {
        this.model.set(this.$(e.target).attr('name'), e.target.value.replace(/([&()!}[~"/{*+:.$^\\|?\]])/g, '\\$1'));
    },
    updateOnEnter: function(e) {
        if (e.keyCode != 13) return;
        this.update(e);
    }
});

var DropDownMenuItem = Marionette.View.extend({
    tagName: "li",
    className: "dropdown-item menu-item",
    template: "#userDropdownFilterSelection",
    ui: {
        "checkbox": "input[type='checkbox']"
    },
    events: {
        "click": function(e) {

            var checkbox = this.ui.checkbox;
            var checked = checkbox.prop("checked");
            if (!$(e.target).is('[type="checkbox"]')) {
                checkbox.prop("checked", !checked);
            }
            if (checkbox.prop("checked") && this.options.max && (this.model.collection.filter({ selected: true }).length >= this.options.max)) {
                checkbox.prop("checked", false);
                return;
            }
            checkbox.prop("checked") ? this.model.set("selected", true) : this.model.set("selected", false);

            this.triggerMethod('select:item', this);
            e.stopPropagation();
        }
    },
    templateContext: function() {
        var text = this.options.resourceKeyAttribute ? Labels[this.model.get(this.options.resourceKeyAttribute)] : (this.model.get('text') || this.model.get('id'));
        var value = this.options.resourceKeyAttribute ? this.model.get(this.options.resourceKeyAttribute) : this.model.get('id');
        _.contains(this.options.valueModel.get("value"), this.model.id) && this.model.set("selected", true);

        return {
            options: this.options,
            text: text,
            value: value,
            checked: _.contains(this.options.valueModel.get("value"), value) ? "checked" : ""
        };
    }
});

var DropDownMenuCollectionView = Marionette.CollectionView.extend({
    tagName: "ul",
    className: "dropdown-menu textcolor",
    childView: DropDownMenuItem,
    childViewEvents: {
        'select:item': function(childview) {
            this.triggerMethod('child:select:item', childview);
        }
    },
    childViewOptions: function() {
        var options = _.clone(this.options);
        return options;
    },
    itemFilter: function(value) {
        var filter = value && value.toUpperCase();
        _.each(this.$el.find(".menu-item"),
            function(a) {
                if (a.textContent.toUpperCase().indexOf(filter) > -1) {
                    a.style.display = "";
                } else {
                    a.style.display = "none";
                }
            }
        );
    }
});

var MultiSelectDropDownView = Selection.extend({
    template: "#multiSelectLayout",
    ui: {
        'selectedItem': "#selectedItem",
        "selected": "#selected",
        'toggleButton': ".dropdown-toggle",
        remove: '#remove'
    },
    events: {
        'click @ui.remove': function() { this.model.collection.remove(this.model); },
        "shown.bs.dropdown": function() {
            if (!this.ui.selected.is(':focus')) {
                this.ui.selected.focus();
                this.ui.selected.attr("title", Labels.Select);
            }
        },
        "hidden.bs.dropdown": function() {
            this.ui.selected.is(':focus') && this.ui.toggleButton.dropdown('toggle');
        },
        "hide.bs.dropdown": function() {
            this.getChildView('dropdownMenu').itemFilter("");
        },
        "keyup #selected": function() {
            this.getChildView('dropdownMenu') && this.getChildView('dropdownMenu').itemFilter(this.ui.selected.val());
        },
        "focus #selected": function() {
            this.ui.selected.attr("placeholder", "");
            this.ui.toggleButton.attr("aria-expanded") == "false" && this.ui.toggleButton.dropdown('toggle');
        },
        "focusout #selected": function() {
            var selections = _.map(this.collection.where({ selected: true }), function(item) {
                return item.get('text') || item.get('id');
            });
            var selectedText = _.any(selections) ? selections.toString().replace(/,/g, ", ") : Labels.Select;

            this.ui.selected.val("");

            this.ui.selected.attr("placeholder", selectedText);
            this.ui.selected.attr("title", selectedText);
        }
    },
    regions: {
        dropdownMenu: {
            el: '.dropdown-menu',
            replaceElement: true
        }
    },
    childViewEvents: {
        'child:select:item': 'childItemSelected'
    },
    childItemSelected: function(childView) {
        this.updateButtonDropdownValue(childView.model);
    },
    updateButtonDropdownValue: function() {
        var selected = this.ui.selected;

        var selections = _.map(this.collection.where({ selected: true }), function(item) {
            return item.get('text') || item.get('id');
        });
        var selectionValues = _.map(this.collection.where({ selected: true }), function(item) {
            return item.get('id');
        });
        selected.text("");
        selected.val("");

        var selectedText = _.any(selections) ? selections.toString().replace(/,/g, ", ") : Labels.Select;
        selected.attr("placeholder", selectedText);
        selected.attr("title", selectedText);

        this.model.set("value", selectionValues ? selectionValues : []);
        this.model.set("valueText", selections ? selections : []);
    },
    onRender: function() {
        var dropdownOptions = _.sortBy(this.model.get('choices'), 'text') || _.sortBy(this.model.get('choices'), 'id');
        // Loading the regions as option for region model
        if (this.model.get('name') == 'region') {
            dropdownOptions = dropdownOptions.concat(_.sortBy(Resources.Regions, 'text'));
            // Below change is to remove UnitedStates option from the region filter because it has subcountries
            dropdownOptions = _.reject(dropdownOptions, function(geo) {
                return geo._id == "/Americas/UnitedStates/";
            });
        }
        if (this.model.get('name') == 'role') {
            dropdownOptions = dropdownOptions.concat(_.sortBy(fetchRolesText(), 'text'));
        }
        this.collection = new Backbone.Collection(dropdownOptions);

        this.showChildView("dropdownMenu", new DropDownMenuCollectionView({ collection: this.collection, valueModel: this.model }));
    },
    onAttach: function() {
        var selectedText = this.model.get('valueText') ?
            this.model.get('valueText').toString().replace(/,/g, ", ") : Labels.Select;

        this.ui.selected.attr("placeholder", selectedText);
        this.ui.selected.attr("title", selectedText);
    },
    templateContext: function() {
        return {
            options: this.options
        };
    }
});

var Selections = Marionette.CollectionView.extend({
    childView: function() {
        return MultiSelectDropDownView;
    },
    filter: function(child) {
        return child.get('controlType') !== '';
    }
});

var Layout = Marionette.View.extend({
    collectionEvents: {
        'add': 'reset',
        'change': 'run',
        'remove reset': 'remove'
    },
    events: {
        'click @ui.clear': function() { this.collection.reset(); },
        'click @ui.menu': function() { this.$('.sub-option ul').toggle(false); },
        'click @ui.save': 'save'
    },
    regions: {
        filters: { el: '#filters', replaceElement: true },
        selections: '#selections'
    },
    template: '#userFilterLayout',
    ui: {
        actions: '#filterActions',
        apply: '#apply',
        clear: '#clear',
        menu: '#menu',
        save: '#save',
        selections: '#selections'
    },
    remove: function() {
        this.reset();
        this.run(); 
    },
    reset: function() {
        var selection = !!this.collection.length;

        this.ui.selections.toggleClass('hidden', !selection);
        this.ui.actions.toggleClass('hidden', !selection);
        if (!selection) {
            this.options.queries.get('').set({selected: false}).set({ aggregate: {}, selected: true });
        }
    },
    run: function() {
        var query = this.collection.findWhere({ name: 'region' }) || this.collection.findWhere({ name: 'role' });
        var filterModels = buildFilters();
        var geoTemplate = filterModels.findWhere({ name: 'region' }).get('template');
        var roleTemplate = filterModels.findWhere({ name: 'role' }).get('template');
        var aggregate = [];
        var criteria = [];
        var filteredGeos = [];
        var filteredRoles = [];

        var filteredValues = _.chain(this.collection.toJSON()).reject({ name: '' }).groupBy('name').each(function(values, key) {
            var filter = this.options.filters.findWhere({ name: key });
            return filter;
        }, this).value();
        var filterKeys = Object.keys(filteredValues);
        filterKeys.forEach(function(key) {
            if(key === 'region') {
                filteredValues[key].forEach(function(filterObj) {
                    if(filterObj.value && filterObj.value.length) {
                        filterObj.value.forEach(function(filterVal) {
                            filteredGeos.push(filterVal)
                        })
                    }
                }) 
            } else if(key === 'role') {
                filteredValues[key].forEach(function(filterObj) {
                    if(filterObj.value && filterObj.value.length) {
                        filterObj.value.forEach(function(filterVal) {
                            filteredRoles.push(filterVal)
                        })
                    }
                }) 
            }
        });

        filteredRoles =  _.uniq(filteredRoles);
        filteredGeos =  _.uniq(filteredGeos);
        var roleRegexVal = filteredRoles.length ? "^(" + filteredRoles.toString().replaceAll(',', '|') + ")" : "";
        if(!filteredGeos.length && filteredRoles.length) {
            var $elemMatch = {};
            $elemMatch["roleId"] = JSON.parse(roleTemplate.replace(/{{value}}/g, roleRegexVal));
            criteria.push({ roles:{ $elemMatch }, active: true});
        } else if(filteredGeos.length) {
            _.forEach(filteredGeos, function(geo) {
                var $elemMatch = JSON.parse(geoTemplate.replace(/{{value}}/g, geo));
                if(filteredRoles.length) $elemMatch["roleId"] = JSON.parse(roleTemplate.replace(/{{value}}/g, roleRegexVal));
                criteria.push({ roles:{ $elemMatch }, active: true});
            });
        }

        if (criteria.length) {
            aggregate.push({ $match:{ $or: criteria }});
        }
        if(query && query.get('type') === FilterType.Simple) {
            this.options.queries.get('').set({selected: false}).set({ aggregate: aggregate, selected: true, filteredGeos, filteredRoles  });
        }
    }
});

module.exports.show = function(options) {
    options = _.extend(options, { filters: buildFilters() });

    var region = options.region;
    var queries = options.queries;
    var collection = transform(options);
    var selections = new Backbone.Collection();
    var layout = new Layout(_.extend({}, options, {
        collection: selections
    }));

    region.show(layout);
    layout.getRegion('filters').show(new Choices(_.extend({}, options, { collection: collection, selections: selections })));
    layout.getRegion('selections').show(new Selections({ collection: selections }));
    queries.on('change:selected', function(query) {
        if (query.get('selected') && query.get('type')) {

            selections.length > 0 && selections.reset();
            selections.add(new Backbone.Model({
                id: query.id,
                filter: query.get('filter'),
                name: '',
                text: query.get('text') + text,
                type: query.get('type'),
                value: query.get('keyword')
            }));
        }
    });
};


// WEBPACK FOOTER //
// ./js/Modules/User/UserFilters.js